import { slicedToArray as _slicedToArray } from './_virtual/_rollupPluginBabelHelpers.mjs';
import { forwardRef, useState, useCallback, useImperativeHandle, useEffect } from 'react';
import { jsx } from 'react/jsx-runtime';

var OverlayController = /*#__PURE__*/forwardRef(function OverlayController(_ref, ref) {
  var OverlayElement = _ref.overlayElement,
      onExit = _ref.onExit;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var handleClose = useCallback(function () {
    return setIsOpen(false);
  }, []);
  useImperativeHandle(ref, function () {
    return {
      close: handleClose
    };
  }, [handleClose]);
  useEffect(function () {
    // NOTE: requestAnimationFrame이 없으면 가끔 Open 애니메이션이 실행되지 않는다.
    requestAnimationFrame(function () {
      setIsOpen(true);
    });
  }, []);
  return /*#__PURE__*/jsx(OverlayElement, {
    isOpen: isOpen,
    close: handleClose,
    exit: onExit
  });
});

export { OverlayController };
